import { Button as DevButton } from 'devextreme-react/button';
import React, { useEffect, useState } from "react";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import SendBienLaiModal from './SendBienLaiModal';
type ThuPhiSendBienLaiBtnProps = {
    disabled: boolean,
    sf_mucphaithu: sf_mucphaithu,
    ts_hocsinh_id: number, 
    isNeedToShowPopUp?: boolean,
    onPopUpOpened?: () => void
}

const ThuPhiSendBienLaiBtn = (props: ThuPhiSendBienLaiBtnProps) => {
    const [isShowPopUp, setIsShowPopUp] = useState<boolean>( props.isNeedToShowPopUp || false);

    useEffect(() => {
        if (props.isNeedToShowPopUp) {
            setIsShowPopUp(true);
            props.onPopUpOpened?.();
        }
    }, [props.isNeedToShowPopUp]);

    return (
        <>
            <DevButton
                text="Gửi email"
                type="success"
                stylingMode="text"
                icon="todo"
                className="p-btn-devextreme"
                disabled={props.disabled}
                onClick={() => {
                    setIsShowPopUp(true);
                }}
            />
            {isShowPopUp && (
                <SendBienLaiModal
                    onClose={() => {
                        setIsShowPopUp(false);
                    }}
                    sf_mucphaithu={props.sf_mucphaithu}
                    ts_hocsinh_id={props.ts_hocsinh_id}
                />
            )}
        </>
    );
}

// type SendBienLaiModalProps = {
//     onClose: () => void,
//     sf_mucphaithu: sf_mucphaithu,
//     ts_hocsinh_id: number
// }

// const SendBienLaiModal = (props: SendBienLaiModalProps) => {
//     const [suggest_emails, set_suggest_emails] = useState<{ email: string }[]>([]);
//     const [email_to_send_when_finish, set_email_to_send_when_finish] = useState<string[]>([]);
//     const [isSaving, SetIsSaving] = useState<boolean>(false);

//     useEffect(() => {
//         handleReloadEmail();
//     }, [props.ts_hocsinh_id]);

//     const handleReloadEmail = async () => {
//         const res = await hocSinhApi.selectParentEmail(props.ts_hocsinh_id);
//         if (res.is_success) {
//             set_suggest_emails(res.data);
//         }
//     }

//     const suggestEmailDataSource = new DataSource({
//         store: {
//             data: suggest_emails,
//             type: 'array',
//             key: 'email'
//         }
//     });

//     const customItemCreating = (args: any) => {
//         if (!args.text) {
//             args.customItem = null;
//             return;
//         }
//         const newItem = { email: args.text };

//         args.customItem = suggestEmailDataSource.store().insert(newItem)
//             .then(() => suggestEmailDataSource.load())
//             .then(() => {
//                 return newItem;
//             })
//             .catch((error) => {
//                 throw error;
//             });
//     }

//     const hanldeSubmit = async () => {
//         SetIsSaving(true);

//         const res = await bienLaiThuApi.send_bienlai({
//             sf_mucphaithu_id: props.sf_mucphaithu.id,
//             email: email_to_send_when_finish.join(",") // Chuyển mảng thành chuỗi, phân cách bởi dấu phẩy
//         });

//         if (res.is_success) {
//             showNotify({ message: "Đã gửi email biên lai thu phí", type: "success" });
//             props.onClose();
//         } else {
//             showNotify({ message: "Không gửi được biên lai", type: "warning" });
//         }

//         SetIsSaving(false);
//     }

//     return (
//         <DefaultPopup title="Gửi thư xác nhận đến PHHS">
//             <div className="pop-up-form">
//                 <div className="col-md-12 padding-top-1rem">
//                     <h4>Chọn Email từ danh sách bên dưới hoặc điền email mới để gửi</h4>
//                     <div className="margin-bottom-5">Gửi tới Email:</div>
//                     <br />
//                     {/* <SelectBox
//                         dataSource={suggestEmailDataSource}
//                         displayExpr="email"
//                         valueExpr="email"
//                         acceptCustomValue={true}
//                         stylingMode="outlined"
//                         value={email_to_send_when_finish}
//                         onCustomItemCreating={customItemCreating}
//                         onValueChanged={(e) => {
//                             set_email_to_send_when_finish(e.value || []);
//                         }}
//                         showSelectionControls={true}
//                         showDropDownButton={true}
//                     /> */}

//                     <TagBox
//                         items={suggest_emails}
//                         showSelectionControls={true}
//                         searchEnabled
//                         displayExpr={'email'}
//                         valueExpr={'email'}
//                         value={email_to_send_when_finish}
//                         multiline={true}
//                         stylingMode="outlined"
//                         width={'100%'}
//                         showClearButton={true}
//                         height={'auto'}
//                         applyValueMode="useButtons"
//                         acceptCustomValue={true}
//                         onValueChanged={(e: any) => {
//                             set_email_to_send_when_finish(e.value || []);
//                         }}
//                         onCustomItemCreating={(e: any) => {
//                             const newItem = e.text.trim();
//                             const lowerCasedNewValue = newItem.toLowerCase();
//                             if (newItem && !suggest_emails.some((item:any) => item.email.toLowerCase() === lowerCasedNewValue)) {
//                                 const newEmail = { email: newItem };
//                                 set_suggest_emails([...suggest_emails, newEmail]);
//                                 e.customItem = new Promise(resolve => {
//                                     resolve(newEmail);
//                                 });
//                                 set_email_to_send_when_finish([...email_to_send_when_finish, newEmail.email]);
//                             }
//                         }}
//                     />
//                     <br />
//                 </div>
//             </div>
//             <div className="pop-up-actions">
//                 <Button type="normal" text="Đóng" onClick={props.onClose} />{' '}
//                 <Button isLoading={isSaving} type="success" text="Gửi thư xác nhận" onClick={hanldeSubmit} />{' '}
//             </div>
//         </DefaultPopup>
//     );
// }

export default ThuPhiSendBienLaiBtn;
